import image from '@/assets/images/manufacturers/diehl.png';
import { option } from '@/util/container';
import { MANUFACTURERS } from '..';

export default option(MANUFACTURERS, async () => ({
  name: 'DIEHL',
  label: 'Diehl',
  image,
}));
